import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{staticClass:"mx-auto mt-10",attrs:{"max-width":"300"}},[_c('img',{attrs:{"src":_vm.post.qr_code,"width":"100%","alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }